import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ContractDetailsContainerStyled } from './style';

type Props = {
  title?: string;
  value?: string;
};

const AdditionalRequirement = ({ title, value }: Props) => {
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        ADDITIONAL REQUIREMENT
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title">{title} : </Typography>
          <Typography className="value"> {value}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};

export default AdditionalRequirement;
